// Browser-side cache so EventsSection (home) and EventsPage share the same data.
// Both call fetchEvents() — first caller fetches, second gets the cached promise.

const cache    = new Map(); // key → { items, ts }
const inFlight = new Map(); // key → Promise<items>
const CACHE_TTL = 10 * 60 * 1000; // 10 minutes

export async function fetchEvents(lang, limit) {
  const key    = `${lang}:${limit}`;
  const cached = cache.get(key);
  const now    = Date.now();

  if (cached && now - cached.ts < CACHE_TTL) return cached.items;

  if (inFlight.has(key)) return inFlight.get(key);

  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 8000);

  const promise = fetch(`/api/events.php?lang=${lang}&limit=${limit}`, { signal: controller.signal })
    .then(r => {
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      return r.json();
    })
    .then(data => {
      clearTimeout(timer);
      if (data.status !== 'ok' || !Array.isArray(data.items)) throw new Error('Bad response');
      cache.set(key, { items: data.items, ts: Date.now() });
      inFlight.delete(key);
      return data.items;
    })
    .catch(err => {
      clearTimeout(timer);
      inFlight.delete(key);
      if (cached) return cached.items; // return stale on error
      throw err;
    });

  inFlight.set(key, promise);
  return promise;
}
